import { CdkTrapFocus } from '@angular/cdk/a11y';
import { NgClass } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, OnInit, viewChild } from '@angular/core';

import { ModalContent } from '@ap/modal';

import type { ApCalendarView } from '../../date-input.model';
import { ApCalendarComponent } from '../calendar.component';
import { ApCalendarControlComponent } from '../control/calendar-control.component';

import { apCalendarModalAnimations } from './calendar-modal.animations';

/**
 * Component used as the content for the datepicker dialog and popup. We use this instead of using
 * ApCalendar directly as the content so we can control the initial focus. This also gives us a
 * place to put additional features of the popup that are not part of the calendar itself in the
 * future. (e.g. confirmation buttons).
 *
 * @docs-private
 */
@Component({
    selector: 'ap-calendar-content',
    templateUrl: './calendar-modal.component.html',
    styleUrls: ['./calendar-modal.component.scss'],
    host: {
        class: 'ap-date-content',
        '[@transformPanel]': '"enter"', // eslint-disable-line @typescript-eslint/naming-convention
        '[class.mat-datepicker-content-touch]': 'true' // eslint-disable-line @typescript-eslint/naming-convention
    },
    animations: [apCalendarModalAnimations.transformPanel, apCalendarModalAnimations.fadeInCalendar],
    exportAs: 'apDateContent',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ApCalendarComponent, CdkTrapFocus, NgClass]
})
export class ApCalendarModalComponent extends ModalContent<ApCalendarControlComponent> implements AfterViewInit, OnInit {
    /** Reference to the internal calendar component. */
    readonly _calendar = viewChild(ApCalendarComponent);

    /** Reference to the datepicker that created the overlay. */
    public datepicker: ApCalendarControlComponent;

    ngOnInit() {
        this.datepicker = this.modalOptions.options;
    }

    ngAfterViewInit() {
        this._calendar().focusActiveCell();
        this._calendar().stateChanges.subscribe(() => this.setTitle(this._calendar().currentView));
    }

    private setTitle(view: ApCalendarView) {
        this.modalOptions.title = this.datepicker.getTitle(view);
    }
}
